export const CheckIcon: React.FC<{
	className?: string;
	fillColor?: string;
	width?: number | string;
	height?: number | string;
}> = ({ className, fillColor = "#22C55E", width = 14, height = 14 }) => {
	return (
		<svg
			className={className}
			width={width}
			height={height}
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 7C0 3.13401 3.13401 0 7 0C8.85651 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7ZM6.811 9.527L10.01 5.327V5.306C10.1626 5.10593 10.1968 4.83967 10.0998 4.60753C10.0028 4.37538 9.78933 4.21261 9.53979 4.18053C9.29025 4.14845 9.04255 4.25193 8.89 4.452L6.244 7.952L5.103 6.496C4.9492 6.29843 4.70168 6.19793 4.45368 6.23234C4.20568 6.26675 3.99487 6.43086 3.90068 6.66284C3.80648 6.89482 3.8432 7.15943 3.997 7.357L5.705 9.534C5.83858 9.70304 6.04255 9.80116 6.258 9.8C6.47465 9.79948 6.67884 9.69867 6.811 9.527Z"
				fill={fillColor}
			/>
		</svg>
	);
};
